const pixelsPerUnit = 4;

export default {
  toPx(units) {
    return units * pixelsPerUnit;
  }
};
